/**
 * The class strings `/build-vs-buy` repeats across its six sections.
 *
 * They live here rather than in the page because the decision table was split
 * out of it, and a heading that is `text-xl font-semibold` in one file and
 * `text-lg font-semibold` in the other is exactly the drift a split introduces
 * when the shared vocabulary stays behind. Five constants, one home, both
 * consumers import them.
 */

/** A section's `<h2>`. */
export const SECTION_HEADING = 'text-xl font-semibold text-[color:var(--bd-ink)]';

/** The sentence under a section heading. */
export const SECTION_INTRO = 'mt-2 text-sm leading-relaxed text-[color:var(--bd-muted)]';

/** A bordered card in one of the page's grids. */
export const ITEM_CARD = 'flex flex-col gap-1 rounded-lg border border-[color:var(--bd-line)] p-4';

/** The bold line inside a card. */
export const ITEM_TITLE = 'text-sm font-semibold text-[color:var(--bd-ink)]';

/** The explanatory line inside a card. */
export const ITEM_DETAIL = 'text-sm leading-relaxed text-[color:var(--bd-muted)]';
